module.exports = __webpack_public_path__ + "img/Image30.09da2ce6.jpg";